import React from 'react';
import styled from 'styled-components';
import SkeletonLine from '../SkeletonLine';

const CartItemContentS = styled.div`
  display: flex;
  margin-bottom: 12px;
`;
const CartItemInfo = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
`;
const StyledSkeletonLine = styled(SkeletonLine)`
  margin: 0 4px;
  margin-bottom: 8px;
`;

const CollapsedCartItemContentS = styled.div`
  display: flex;
  margin-right: 12px;
`;

export const CartItemSkeleton = (): JSX.Element => (
  <CartItemContentS>
    <div>
      <SkeletonLine width="100px" height="100px" />
    </div>
    <CartItemInfo>
      <StyledSkeletonLine width="80%" />
      <StyledSkeletonLine width="50%" />
      <StyledSkeletonLine width="25%" />
    </CartItemInfo>
  </CartItemContentS>
);

export const CollapsedCartItemSkeleton = (): JSX.Element => (
  <CollapsedCartItemContentS>
    <SkeletonLine width="65px" height="65px" />
  </CollapsedCartItemContentS>
);
